<section class="mm-checkout" *ngIf="amountMga > 0; else noAmount">
    <div class="mm-amount">
        <span class="mm-amount-label">Montant (MGA)</span>
        <span class="mm-amount-value">{{ amountMga | number : "1.0-0" }} Ar</span>
    </div>

    <p class="mm-label">Choisir l'opérateur</p>
    <div class="mm-operators" role="group" aria-label="Opérateur mobile money">
        <button
            type="button"
            class="mm-op"
            *ngFor="let o of operators"
            [class.mm-op-active]="selected === o.id"
            [style.--op-accent]="o.accent"
            (click)="selectOperator(o.id)"
        >
            {{ o.label }}
        </button>
    </div>

    <div class="mm-phone" *ngIf="selected">
        <div class="rayalina-auth-form">
            <div class="field mm-intl-phone-field">
                <label for="mm-payer-phone">Numéro du compte mobile money</label>
                <div class="rayalina-intl-input" (focusout)="phoneControl.markAsTouched()">
                    <intl-tel-input
                        [formControl]="phoneControl"
                        [inputProps]="{ id: 'mm-payer-phone', autocomplete: 'tel' }"
                        [initOptions]="intlTelOptions"
                    ></intl-tel-input>
                </div>
                <span class="field-error" *ngIf="phoneControl.touched && phoneControl.hasError('required')">
                    Veuillez indiquer votre numéro.
                </span>
                <span class="field-error" *ngIf="phoneControl.touched && phoneControl.hasError('validatePhoneNumber')">
                    Veuillez entrer un numéro mobile malgache valide.
                </span>
            </div>
        </div>
    </div>

    <p class="mm-loading-banner" *ngIf="loading && !instruction">Création de la demande de paiement…</p>

    <p class="mm-auto-hint" *ngIf="selected && isPayerPhoneValid() && !instruction && !loading && !error">
        La demande sera créée automatiquement ; le statut sera mis à jour sans action de votre part (validité 5 minutes).
    </p>

    <p class="mm-error" *ngIf="error">{{ error }}</p>

    <div class="mm-instructions" *ngIf="instruction as inst">
        <p class="mm-auto-banner" *ngIf="status === 'PENDING'">
            Suivi automatique : notre système detecte le statut jusqu’à confirmation, échec ou expiration (5 min).
        </p>

        <h3 class="mm-instructions-title">Étapes sur votre téléphone</h3>
        <ol class="mm-steps">
            <li>
                Sur ce téléphone, utilisez le lien ci-dessous pour ouvrir le composeur avec le code USSD (sinon copiez le
                code).
            </li>
            <li>Validez le montant <strong>{{ inst.amountMga | number : "1.0-0" }} Ar</strong> sur votre téléphone.</li>
        </ol>

        <div class="mm-ussd-block">
            <span class="mm-ussd-label">Code USSD</span>
            <a class="mm-ussd-tel" [href]="ussdTelHref(inst.ussdDialString)">Composer le code</a>
            <code class="mm-ussd-code">{{ inst.ussdDialString }}</code>
            <button type="button" class="mm-ghost" (click)="copyText(inst.ussdDialString)">Copier le code</button>
        </div>

        <div class="mm-ref-block">
            <span class="mm-ussd-label">Référence commande</span>
            <code class="mm-ussd-code mm-ref">{{ inst.referenceId }}</code>
            <button type="button" class="mm-ghost" (click)="copyText(inst.referenceId)">Copier la référence</button>
        </div>

        <p class="mm-hint">{{ inst.customerHint }}</p>

        <div class="mm-status" [attr.data-status]="status">
            <span class="mm-status-label">Statut du paiement</span>
            <span class="mm-status-pill" *ngIf="status === 'PENDING'">En attente</span>
            <span class="mm-status-pill mm-paid" *ngIf="status === 'PAID'">Payé</span>
            <span class="mm-status-pill mm-bad" *ngIf="status === 'FAILED'">Échec</span>
            <span class="mm-status-pill mm-bad" *ngIf="status === 'EXPIRED'">Expiré</span>
        </div>
        <p class="mm-failure-reason" *ngIf="(status === 'EXPIRED' || status === 'FAILED') && lastStatusPayload?.failureReason">
            {{ lastStatusPayload?.failureReason }}
        </p>
    </div>
</section>

<ng-template #noAmount>
    <p class="mm-skip">Aucun paiement requis pour cette formule.</p>
</ng-template>
